import { useMemo, useState } from 'react'

import { CourtReporterFilters } from './CourtReporterFilterControls'

import { CalendarCourtReporterAdminEvent } from '@/apiClient'
import { toCalendarEvent } from '@/components/Calendar/Calendar'
import { useCalendarEvents } from '@/queries/calendar'
import * as urls from '@/queries/urls'
import { CalendarParams } from '@/queries/useCalendarParams'
import { getEventFormat } from '@/utils/parrot'
import { normalize } from '@/utils/string'

export const filterCourtReporterEvents = (
  events: CalendarCourtReporterAdminEvent[],
  filters: CourtReporterFilters,
): CalendarCourtReporterAdminEvent[] => {
  const matches = (value: string, search: string | undefined) =>
    normalize(value).includes(normalize(search ?? ''))

  return events.filter(
    event =>
      filters.general_status_in.includes(event.general_status) &&
      matches(event.name, filters.event_search) &&
      matches(event.team.name, filters.team_search) &&
      matches(event.team.organization.name, filters.organization_search) &&
      (filters.court_reporter === undefined ||
        event.court_reporter_booking?.court_reporter_id ===
          filters.court_reporter.id) &&
      (filters.event_format === undefined ||
        getEventFormat(event) === filters.event_format) &&
      (!filters.state_in ||
        filters.state_in.length === 0 ||
        (typeof event.case.state === 'string' &&
          filters.state_in.includes(event.case.state))) &&
      (!filters.timezone_in ||
        filters.timezone_in.length === 0 ||
        (!!event.timezone && filters.timezone_in.includes(event.timezone))),
  )
}

export const useFilteredCourtReporterEvents = ({
  calendarParams,
  initialFilters,
}: {
  calendarParams: CalendarParams
  initialFilters: CourtReporterFilters
}) => {
  const [filters, setFilters] = useState<CourtReporterFilters>(initialFilters)

  const {
    events: allEvents,
    isFetching,
    refetch,
  } = useCalendarEvents<CalendarCourtReporterAdminEvent>({
    url: urls.calendarAdminCourtReporterEvents(),
    calendarParams,
  })

  const events = useMemo(
    () => filterCourtReporterEvents(allEvents, filters).map(toCalendarEvent),
    [allEvents, filters],
  )

  return {
    events,

    filters,
    setFilters,

    isFetching,
    refetch,
  }
}
